import { render, staticRenderFns } from "./c_input_item.vue?vue&type=template&id=088886ac&scoped=true"
import script from "./c_input_item.vue?vue&type=script&lang=js"
export * from "./c_input_item.vue?vue&type=script&lang=js"
import style0 from "./c_input_item.vue?vue&type=style&index=0&id=088886ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088886ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088886ac')) {
      api.createRecord('088886ac', component.options)
    } else {
      api.reload('088886ac', component.options)
    }
    module.hot.accept("./c_input_item.vue?vue&type=template&id=088886ac&scoped=true", function () {
      api.rerender('088886ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_input_item.vue"
export default component.exports